import store from '@/store';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Accounts, DataEntity } from '@/entity/clients/Accounts/allclients.types';
import { getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { prepareFormData } from '@/store/utils/formDataHelper';

@Module({
    namespaced: true,
    name: 'clientsAccountsAll',
    store,
    dynamic: true,
})
class clientsAccountsAllModule extends VuexModule implements IStoreReady {
    items: Accounts | null = null;
    item: DataEntity | null = null;

    itemsLoaded = false;
    itemLoaded = false; //
    ready = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: Accounts; itemsLoaded: boolean }> {
        let itemsLoaded = false;
        const items = await store.$repository.clientsAccountsAll.fetchAll(prepareFormData(data));
        if (items) {
            itemsLoaded = true;
        }
        return { items, itemsLoaded };
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ item: DataEntity; itemLoaded: boolean }> {
        let itemLoaded = false;
        const item = await store.$repository.clientsAccountsAll.fetchData(data);
        if (item) {
            itemLoaded = true;
        }
        return { item, itemLoaded };
    }
}
export const ClientsAccountsAllStore = getModule(clientsAccountsAllModule);
